/* =====================================================================
   Browns Digital Studio — client bootstrap (v6)
   Live values are inlined into index.html at deploy time. If that
   marker is still empty, fall back to api/public-config.php.
   UI-only constants stay here; secrets never do.
===================================================================== */
"use strict";

var SUPABASE_URL = "";
var SUPABASE_ANON_KEY = "";
var API_BASE = location.origin + "/api/";
var APP_ORIGIN = "";
globalThis.APP_ORIGIN = APP_ORIGIN;
var QA_MODE = false;
var PAYSTACK_PUBLIC_KEY = "";
var STAGING_BASE_URL = "https://studio.brownsdigital.org/s/";

const ALLOWED_PLANS = ["free", "pro", "studio", "build", "forge", "architect"];
const PLAN_RULES = {
  free:      { label: "Draft",    sites: 1,        customDomain: false, customCss: false, collaborators: 0, monthlyCredits: 0 },
  build:     { label: "Build",    sites: 1,        customDomain: false, customCss: true,  collaborators: 0, monthlyCredits: 250 },
  forge:     { label: "Forge",    sites: 3,        customDomain: false, customCss: true,  collaborators: 3, monthlyCredits: 750 },
  architect: { label: "Architect", sites: Infinity, customDomain: true, customCss: true, collaborators: Infinity, monthlyCredits: 2500 },
  pro:       { label: "Forge",    sites: 3,        customDomain: false, customCss: true,  collaborators: 3, monthlyCredits: 750 },
  studio:    { label: "Architect", sites: Infinity, customDomain: true, customCss: true, collaborators: Infinity, monthlyCredits: 2500 }
};

const URLS = {
  brandIcon: "/assets/img/bd-logo.svg",
  site:    "https://brownsdigital.org/",
  pricing: "https://brownsdigital.org/#pricing",
  docs:    "https://docs.brownsdigital.org/",
  help:    "https://help.brownsdigital.org/",
  status:  "https://status.brownsdigital.org/"
};
const CONTACT = "support@brownsdigital.org";

function bdAppOrigin(){
  const o = (typeof APP_ORIGIN === "string" && APP_ORIGIN) ? APP_ORIGIN : location.origin;
  return o.replace(/\/+$/, "");
}

function bdApplyPublicConfig(c){
  if (!c || typeof c !== "object") return false;
  SUPABASE_URL = String(c.supabase_url || "");
  SUPABASE_ANON_KEY = String(c.supabase_anon_key || "");
  if (c.api_base) API_BASE = String(c.api_base);
  if (c.app_origin) APP_ORIGIN = String(c.app_origin).replace(/\/+$/, "");
  globalThis.APP_ORIGIN = APP_ORIGIN;
  QA_MODE = !!c.qa_mode;
  PAYSTACK_PUBLIC_KEY = String(c.paystack_public_key || "");
  if (c.staging_base_url) {
    STAGING_BASE_URL = String(c.staging_base_url);
    if (!STAGING_BASE_URL.endsWith("/")) STAGING_BASE_URL += "/";
  }
  return SUPABASE_URL !== "" && SUPABASE_ANON_KEY !== ""
    && !SUPABASE_URL.includes("YOUR-") && !SUPABASE_ANON_KEY.includes("YOUR-");
}

async function bdLoadConfig(){
  if (bdApplyPublicConfig(globalThis.BD_PUBLIC_CONFIG)) return true;
  try {
    const res = await (globalThis.bdFetch || fetch)(API_BASE + "public-config.php", { cache: "default" }, 8000);
    if (!res.ok) return false;
    return bdApplyPublicConfig(await res.json());
  } catch {
    return false;
  }
}

/** Base for published sites: https://studio…/s/ */
function sitesBaseUrl(){
  const b = (typeof STAGING_BASE_URL === "string" && STAGING_BASE_URL) ? STAGING_BASE_URL : (bdAppOrigin() + "/s/");
  return b.endsWith("/") ? b : b + "/";
}
function prodSiteUrl(slug){
  if (!slug) return "";
  return sitesBaseUrl() + slug + "/";
}
/** Host + path label without scheme, e.g. studio.brownsdigital.org/s/acme */
function prodSiteHostLabel(slug){
  if (!slug) return "";
  return sitesBaseUrl().replace(/^https?:\/\//i, "").replace(/\/$/, "") + "/" + slug;
}
